import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useDispatch } from "react-redux";
import { httpRequest } from "../../redux/Action";
import Loader from "../Loader";
import { toast } from "react-toastify";
import RouteTracker from "../user/TrackUserActivity";

const ProtectedRoute = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if user is authenticated by calling /user/me API
    dispatch(
      httpRequest({
        key: "userGetMe",
        onSuccess: (res) => {
          // console.log("User authenticated:", res);
          
          setIsAuthenticated(true);
        },
        onError: (err) => {
          console.log("User not authenticated:", err);
          // toast.error("Session expired. Please log in again.");
          setIsAuthenticated(false);
        },
      })
    );
  }, [dispatch]);

  // While checking authentication, show loader
  if (isAuthenticated === null) {
    return <Loader />;
  }

  return isAuthenticated ?<> <RouteTracker/>  <Outlet />  </> : <Navigate to="/user/login" replace={true} />;
};

export default ProtectedRoute;
